@if (visible) {
  <div class="setup-modal-backdrop" (click)="close()">
    <div class="setup-modal" (click)="$event.stopPropagation()">
      <div class="setup-modal-header">
        <div class="setup-modal-brand">
          <div class="setup-modal-icon">
            <span class="pi pi-flag"></span>
          </div>
          <div>
            <h2>Setup Needs Attention</h2>
            <p>Complete the required configuration before using Trieon.HR end to end.</p>
          </div>
        </div>
        <button type="button" class="setup-modal-close" (click)="close()" aria-label="Close setup attention modal">
          <span class="pi pi-times"></span>
        </button>
      </div>

      <div class="setup-modal-body">
        <div class="setup-modal-summary">
          <div>
            <div class="setup-summary-label">Current progress</div>
            <div class="setup-summary-value">
              {{ setupAttentionService.completedCount() }} / {{ setupAttentionService.trackedItems().length }} complete
            </div>
          </div>
          <div class="setup-summary-percent">{{ setupAttentionService.progressPercent() }}%</div>
        </div>

        <div class="setup-progress-bar">
          <div class="setup-progress-fill" [style.width.%]="setupAttentionService.progressPercent()"></div>
        </div>

        @if (setupAttentionService.nextSteps().length > 0) {
          <div class="setup-next-banner">
            <span class="setup-next-title">Focus next on:</span>
            <div class="setup-next-links">
              @for (item of setupAttentionService.nextSteps(); track item.key) {
                <button type="button" class="setup-next-link" (click)="goTo(item.route)">
                  {{ item.label }}
                </button>
              }
            </div>
          </div>
        }

        <div class="setup-modal-list">
          @for (item of setupAttentionService.pendingItems(); track item.key) {
            <div class="setup-modal-item">
              <div class="setup-item-icon">
                <span class="pi" [ngClass]="item.icon"></span>
              </div>
              <div class="setup-item-content">
                <div class="setup-item-top">
                  <div>
                    <p class="setup-item-title">{{ item.label }}</p>
                    <p class="setup-item-description">{{ item.description }}</p>
                  </div>
                  <span [class]="setupAttentionService.setupStatusClass(item.status)">
                    {{ setupAttentionService.setupStatusLabel(item.status) }}
                  </span>
                </div>
                <div class="setup-item-bottom">
                  <span class="setup-item-note">{{ item.note }}</span>
                  <button type="button" class="setup-item-action" (click)="goTo(item.route)">
                    {{ item.routeLabel }}
                    <span class="pi pi-arrow-right"></span>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="setup-modal-footer">
        <button type="button" class="p-button p-component p-button-text" (click)="close()">
          <span class="p-button-label">Close for now</span>
        </button>
      </div>
    </div>
  </div>
}
